import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { ContractRouterClient } from "@orpc/contract";
import type { DrokContract } from "@rakazo/contracts";
import { CLIENT_BUILD_HEADER, formatClientBuild } from "@rakazo/contracts";
import { clientCorrelationHeaders } from "@rakazo/logging/monitoring";
import { CLIENT_BUILD } from "../lib/client-build";
import { recheckSessionOnUnauthorized, withSpaceHeaders } from "../lib/rpc";

const link = new RPCLink({
  url: () =>
    typeof window === "undefined"
      ? "http://127.0.0.1:5173/drok-rpc"
      : `${window.location.origin}/drok-rpc`,
  fetch: async (input, init, options) => {
    const request = new Request(input, init);
    const headers = withSpaceHeaders(request.headers);
    if (CLIENT_BUILD) headers.set(CLIENT_BUILD_HEADER, formatClientBuild("web", CLIENT_BUILD));
    for (const [key, value] of Object.entries(clientCorrelationHeaders())) headers.set(key, value);
    const response = await fetch(request, {
      headers,
      credentials: "include",
      signal: options.signal,
    });
    recheckSessionOnUnauthorized(response.status);
    return response;
  },
});

export type DrokRpcClient = ContractRouterClient<DrokContract>;

/** The fork's second oRPC client, served on /drok-rpc beside the upstream /rpc. */
export const drokRpc: DrokRpcClient = createORPCClient(link);
